import React from "react";
import "./Projects.css"
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import ProjectData from "./ProjectData";
import ProjectCard from "./ProjectCard";
// import { EffectFade } from 'swiper';


import { EffectCoverflow, Navigation, Pagination } from "swiper";




function Projects(){
    
    return(
        <div className="projects">
            <div className="project-title">Projects</div>
            <Swiper className="swiper"
                style={{
                    "--swiper-pagination-color": "#ffcb74",
                    // "--swiper-pagination-bullet-active-size": "16px",
                    "--swiper-pagination-bullet-inactive-color": "#ffcb74",
                    "--swiper-pagination-bullet-inactive-opacity": "0.3",
                    "--swiper-navigation-color": "#ffcb74",
                    paddingTop:"20px",
                    // backgroundColor:"#111111"
                }}
                effect={'coverflow'}
                grabCursor={ true }
                centeredSlides = { true }
                loop = { false }
                slidesPerView={'auto'}
                coverflowEffect={
                    {
                        depth:100,
                        rotate: 0,
                        stretch:0,
                        modifier:5
                    }
                }
                pagination ={{el:'.swiper-pagination', clickable: true, }}
                navigation = {{
                    nextEl:'.swiper-button-next',
                    prevEl:'.swiper-button-prev',
                    clickable: true
                }}
                modules={[EffectCoverflow, Pagination, Navigation]}
            >
                
                    {ProjectData.map((val) => {
                        return <SwiperSlide className="swiperSlide" style={{ backgroundColor:"#2f2f2f",display:"flex",justifyContent:"center", alignItems:"center",width:"clamp(320px,50vw,400px)",height:"400px"}}>
                            <ProjectCard id={val.project_id} project_name={val.name} project_desc={val.desc} project_img={val.image} project_link={val.link}/>
                        </SwiperSlide>;
                    })}
                
                
                <div className="slide-controler">
                    <div className="swiper-button-prev swiper-button"></div>
                    <div className="swiper-button-next swiper-button"></div>
                    <div className="swiper-pagination"></div>
                </div>
            </Swiper>
            <div className="project-conclusion">
                Checkout my Github <span><a href="https://github.com/71203mayank" target="_blank" rel = "noreferrer">71203mayank</a></span> for more projects.
            </div>

        </div>
    );
}

export default Projects;